export default __webpack_public_path__ + "static/media/health.8458144e.svg";